import script from "./individual-category-group-item.vue?vue&type=script&lang=ts&setup=true"
export * from "./individual-category-group-item.vue?vue&type=script&lang=ts&setup=true"

import "./individual-category-group-item.vue?vue&type=style&index=0&id=2091924c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2091924c"]])

export default __exports__